import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import styles from './DefaultLayout.module.css'

const DefaultLayout = ({ children, pageContext: { baseUrl } }) => {
  return (
    <div>
      <div className={styles.componentWrapper}>{children}</div>

      <ComponentList baseUrl={baseUrl} />
    </div>
  )
}

export default DefaultLayout

const ComponentList = ({ baseUrl }) => {
  const results = useStaticQuery(
    graphql`
      query {
        allUiComponent {
          nodes {
            url
            data {
              componentName
              componentPath
            }
          }
        }
      }
    `
  )

  const {
    allUiComponent: { nodes: components }
  } = results

  return (
    <div className={styles.componentList}>
      <div className={styles.componentList__inner}>
        <ul>
          <li>
            <CompLink url={baseUrl}>
              <h3>Ui lib!</h3>
            </CompLink>
          </li>

          {components.map(cmp => (
            <li key={cmp.url}>
              <Component url={cmp.url} {...cmp.data} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

const CompLink = ({ url, children }) => (
  <Link
    to={url}
    className={styles.component}
    activeClassName={styles.active}
    partiallyActive={!url.match(/\/$/)}
  >
    {children}
  </Link>
)

const Component = ({ url, componentName, componentPath }) => (
  <CompLink url={url}>
    <h4 className={styles.component__name}>{componentName}</h4>
    <p className={styles.component__desc}>{componentPath}</p>
  </CompLink>
)
